import styled from 'styled-components';

import * as Common from '../../../Styles';

const Theme = Common.Theme;

export const Button = styled(Common.Button)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Dialog = styled(Common.Dialog)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)``;

export const DialogActions = styled(Common.DialogActions)``;

export const FlexRow = styled(Common.FlexRow)``;

export const InputGroup = styled(Common.InputGroup)``;

export const TextField = styled(Common.TextField)``;
